import { render, staticRenderFns } from "./MethodStatementCreateEditPage.vue?vue&type=template&id=28b6e44c&"
import script from "./MethodStatementCreateEditPage.vue?vue&type=script&lang=js&"
export * from "./MethodStatementCreateEditPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports